<template>
  <div class="contentful-content">
    <span
      v-if="show && !applyMarkdown"
      :data-contentful-text="item.Id"
    >
      {{ text }}
    </span>
    <vue-markdown
      v-if="show && applyMarkdown"
      :source="text"
      :data-contentful-text="item.Id"
      :postrender="markdownPostRender"
    />
  </div>
</template>

<script>
import { sprintf } from 'sprintf-js'
import newRelic from '@Shared/lib/new-relic'
import GoogleAnalytics from '@Shared/lib/google-analytics'
import VueMarkdown from 'vue-markdown'

export default {
  name: 'ContentfulText',
  components: {
    VueMarkdown
  },
  props: {
    item: { type: Object, default: null },
    data: { type: Object, default: null },
    applyMarkdown: { type: Boolean, default: false },
    renderInline: { type: Boolean, default: false }
  },
  computed: {
    show () {
      return this.item !== undefined && this.item !== null
    },
    text () {
      if (this.data === null) {
        return this.item.Content
      }

      let result

      try {
        result = sprintf(this.item.Content, this.data)
      } catch (e) {
        result = this.item.Content
        newRelic.noticeError(e)
      }

      return result
    }
  },
  mounted () {
    if (this.applyMarkdown) {
      const aElements = this.$el.getElementsByTagName('a')

      if (aElements.length > 0) {
        for (const aElement of aElements) {
          aElement.addEventListener('click', (event) => {
            let gaCategory, gaLabel

            if (event.target.dataset !== undefined && event.target.dataset.gaCategory !== undefined) {
              gaCategory = event.target.dataset.gaCategory
            } else {
              return
            }

            if (event.target.dataset !== undefined && event.target.dataset.gaLabel !== undefined) {
              gaLabel = event.target.dataset.gaLabel
            } else {
              return
            }

            GoogleAnalytics.trackEvent(gaCategory, 'click', gaLabel)
          })
        }
      }
    }
  },
  methods: {
    markdownPostRender (htmlString) {
      if (this.renderInline === true) { // if rendering inline remove the <p>...</p> tags that Markdown renders by default
        return htmlString.replace(/<p>/, '').replace(/<\/p>/, '')
      }

      return htmlString
    }
  }
}
</script>

<style>
.contentful-content {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/contentful/ContentfulText.vue